import React, { useState } from "react";
import {
    fetchDailyReportSummary,
    fetchDailyReportList
} from "../../api/candidateApi";
import "./ReportsPanel.css";

function ReportsPanel({ candidateId, employeeId }) {
    const [selectedDate, setSelectedDate] = useState("");
    const [summary, setSummary] = useState(null);
    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeFilter, setActiveFilter] = useState(null); 


    const loadSummary = async () => {
        if (!selectedDate) {
            alert("Please select a date");
            return;
        }

        setSummary(null);
        setList([]);
        setLoading(true);

        try {
            const res = await fetchDailyReportSummary(candidateId, employeeId, selectedDate);
            setSummary(res.data);
        } catch (e) {
            console.error(e);
            setSummary(null);
        }

        setLoading(false);
    };

    const loadListByStatus = async (status) => {
        setLoading(true);
        setList([]);

        try {
            const res = await fetchDailyReportList(candidateId, employeeId, selectedDate, status);
            setList([{ status, jobs: res.data }]);
        } catch {
            setList([]);
        }

        setLoading(false);
    };

    const loadAllLists = async () => {
        const statuses = ["APPLIED", "NOT_APPLIED", "NOT_FIT", "UNABLE_TO_APPLY"];
        const all = [];

        setLoading(true);

        for (let s of statuses) {
            const res = await fetchDailyReportList(candidateId, employeeId, selectedDate, s);
            if (res.data?.length > 0) all.push({ status: s, jobs: res.data });
        }

        setList(all);
        setLoading(false);
    };


    return (
        <div className="reports-container">
            <h2>Reports</h2>

            {/* DATE PICKER */}
            <div className="reports-date-picker">
                <label>Select Date:</label>
                <input
                    type="date"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                />
                <button onClick={loadSummary}>Load Summary</button>
            </div>

            {loading && <p>Loading...</p>}

            {/* SUMMARY */}
            {summary && (
                <div className="report-summary-box">
                    <h3>Summary</h3>
                    <ul>
                        <li>Applied: {summary.applied}</li>
                        <li>Not Applied: {summary.notApplied}</li>
                        <li>Not Fit: {summary.notFit}</li>
                        <li>Unable To Apply: {summary.unableToApply}</li>
                    </ul>

                    {/* ACTION BUTTONS */}
                    <div className="report-buttons">
                        <button
                            className={activeFilter === "APPLIED" ? "rp-active" : ""}
                            onClick={() => { setActiveFilter("APPLIED"); loadListByStatus("APPLIED"); }}>
                            Show Applied
                        </button>

                        <button
                            className={activeFilter === "NOT_APPLIED" ? "rp-active" : ""}
                            onClick={() => { setActiveFilter("NOT_APPLIED"); loadListByStatus("NOT_APPLIED"); }}>
                            Show Not Applied
                        </button>

                        <button
                            className={activeFilter === "NOT_FIT" ? "rp-active" : ""}
                            onClick={() => { setActiveFilter("NOT_FIT"); loadListByStatus("NOT_FIT"); }}>
                            Show Not Fit
                        </button>

                        <button
                            className={activeFilter === "UNABLE_TO_APPLY" ? "rp-active" : ""}
                            onClick={() => { setActiveFilter("UNABLE_TO_APPLY"); loadListByStatus("UNABLE_TO_APPLY"); }}>
                            Show Unable To Apply
                        </button>

                        <button
                            className={activeFilter === "ALL" ? "rp-active" : ""}
                            onClick={() => { setActiveFilter("ALL"); loadAllLists(); }}>
                            Show All
                        </button>
                    </div>

                </div>
            )}

            {/* LIST OUTPUT */}
            {!loading && list.length > 0 && (
                <div className="report-lists">
                    {list.map((section) => (
                        <div key={section.status} className="report-section">
                            <h4>{section.status}</h4>
                            <ul>
                                {section.jobs.map((job) => (
                                    <li key={job.id}>
                                        <strong>{job.title}</strong> — {job.company}
                                        <br />
                                        <a href={job.url} target="_blank">{job.url}</a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            )}

            {/* NO DATA */}
            {!loading && summary && list.length === 0 && (
                <p>No data found for selected filters.</p>
            )}
        </div>
    );
}

export default ReportsPanel;
